import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const joeSandbox = defineConnector({
  identifier: "joeSandbox",
  name: "Joe Sandbox",
  tagLine: "Automated malware analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://(www|jbxcloud)\\.joesandbox\\.com/api/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Joe Sandbox](https://www.joesandbox.com/), open the user icon, choose **User Settings > API Key**, and copy the API key shown there.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Joe Sandbox API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://www.joesandbox.com/api/v2/server/online",
    }),
  },
});
